import { FC } from 'react';

export const PostList: FC = () => {
	return <></>;
};
